import React from "react";
import "./styles/Navbar-footer.css";
import { useNavigate } from "react-router-dom";
const Footer = (props) => {
  const history = useNavigate();
  return (
    <div className="Footer">
      <div className="text-line">
        The best captial of all is{" "}
        <span style={{ color: "#295bdc" }}>Human</span>.
      </div>
      <div className="text-line2">
        TRAINERY ONE LLC |
        <span style={{ fontWeight: "200" }}>
          {" "}
          800.397.5215 | support@trainery.one | North Carolina |{" "}
        </span>
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            history("/privacy-agreement");
          }}
        >
          PRIVACY AGREEMENT |{" "}
        </span>
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            history("/service-agreement");
          }}
        >
          SERVICE AGREEMENT |{" "}
        </span>
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            history("/terms-of-service");
          }}
        >
          TERMS OF SERVICE
        </span>
      </div>
    </div>
  );
};

export default Footer;
